import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { LicensePopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface LicenseBusinessPartnerModel {
    licenseId: number
    businessPartnerTypeId: number
    businessPartnerId: number
    included: boolean
    excluded: boolean
}

const AddBusinessPartnerPopup: React.FC<LicensePopupProps> = ({ show, onHide, licenseId, included }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<LicenseBusinessPartnerModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<LicenseBusinessPartnerModel>({
        licenseId: licenseId,
        businessPartnerTypeId: 0,
        businessPartnerId: 0,
        included: included,
        excluded: !included
    });

    useEffect(() => {
        formData.included = included;
        formData.excluded = !included;
        setFormData(formData);

    }, [included]);

    const businessPartnerTypes = useSelectListOptions('api/v1/selectlist/BusinessPartnerTypes', '-- Select business-partner type')
    const businessPartners = useSelectListOptions('api/v1/selectlist/BusinessPartners?activeOnly=true&businessPartnerTypeId=' + formData.businessPartnerTypeId, '-- Select business-partner');

    function submit() {
        if (formData) {
            DataService
                .create<LicenseBusinessPartnerModel>(`api/v1/LicenseBusinessPartners`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'businessPartnerTypeId', label: 'Type', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'businessPartnerId', label: 'Business-partner', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={included ? 'Include business-partner in License' : 'Exclude business-partner from License'}>
            <Popup.Body>
                <SelectListField {...getFieldProps('businessPartnerTypeId')} options={businessPartnerTypes} />
                <SelectListField {...getFieldProps('businessPartnerId')} options={businessPartners} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBusinessPartnerPopup;